<template>
  <div class="about">
    <h2>Audit id:{{ $route.params.audit_id }}</h2>

    <div class="loading" v-if="loading">
        Loading...
    </div>
    <div v-if="error" class="error">
      {{ error }}
    </div>
    <div v-if="audit" class="content">
        <AuditDetails :audit=audit />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AuditDetails from '@/components/AuditDetails.vue'

export default {
  data () {
    return {
        loading: false,
        post: null,
        audit: null
    }
  },
  components: {
      AuditDetails
  },
  created () {
      this.fetchData()
  },
  watch: {
      '$route': 'fetchData'
  },
  methods: {
      fetchData() {
          this.error = this.post = null;
          this.loading = true;
          this.$http.get('v1/audits/' + this.$route.params.audit_id).then(response => {
              this.audit = response.data.response;
              this.loading = false;
          });
      }
  }
}
</script>
